<div *ngIf="supplier" class="card" >
    <div class="card-header">

        <label class="control-label" paflabel="Documents_qualite">Documents qualité</label>
        <doc-histo-button class="float-right" [supplier]="supplier"></doc-histo-button>
    </div>
    <div class="card-body">
        <div class="row mt-2">
            <div class="col">
                <label class="control-label" paflabel="Header_message_quality_doc"></label>
            </div>
        </div>
        <div class="card mt-2">
            <div class="card-header">
                <label class="control-label" paflabel="Avez_vous_les_qualifications_suivantes"></label>
            </div>
            <div class="card-body">
                <div *ngFor="let suppDoc of lstQualifDocs">
                    <supplier-qual-doc-row [lstPafDocuments]="lstPafDocuments" [lstDocTyps]="lstDocTyps" [lstDocStatuts]="lstDocStatuts" [supplier]="supplier" [supplierDoc]="suppDoc" (reloadList)="reloadList($event)" [readonly]="readonlyQualDoc('qualif')"></supplier-qual-doc-row>
                </div> 
            </div>
        </div>
        <div class="card mt-2">
            <div class="card-header">
                <label class="control-label" paflabel="Souhaitez_vous_nous_indiquer_d_autres_documents"></label>
            </div>
            <div class="card-body">
                <div *ngFor="let suppDoc of lstAutresDocs">
                    <supplier-qual-doc-row [lstPafDocuments]="lstPafDocuments" [lstDocTyps]="lstDocTyps" [lstDocStatuts]="lstDocStatuts" [supplier]="supplier" [supplierDoc]="suppDoc" (reloadList)="reloadList($event)" [readonly]="readonlyQualDoc('autres')"></supplier-qual-doc-row>
                </div>  
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-1">
                <label class="control-label" paflabel="Commentaires_relatifs_a_vos_documents"></label>
            </div>
            <div class="col mb-3">
                <textarea class="form-control" name="DocQualComments" [(ngModel)]="supplier.DocQualComments" rows="3"
                    style="width: 100%;height:60px;" [disabled]="(docsQualiteQualifDisabled && docsQualiteAutresDisabled) || !isEditing() "></textarea>
            </div>    
        </div>        
    </div>
</div>
